import './App.css';
import { useState } from 'react';
import ComplaintForm from './compnents/ComplainForm';
import Complaints from './compnents/Show_complaint_data';
import Navbar from './compnents/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './compnents/Footer';
import LoadingBar from 'react-top-loading-bar'
function App() {
  const apiKey = process.env.REACT_APP_NEWS_API
  // const apiKey = "http://localhost:5000"
  const [progress, setProgress] = useState(0)
  return (
    <>
    
      <Router>
        <Navbar />
        <LoadingBar
        height={3}
        color='#f11946'
        progress={progress} 
      />
        <Switch>
          {/* <Route exact path="/">
            
          </Route> */}
          
          <Route exact path="/complaintform">
            <ComplaintForm apiKey={apiKey} setProgress={setProgress}/>
          </Route>
          <Route exact path="/complaints">
            <Complaints apiKey={apiKey} setProgress={setProgress}/>
          </Route>
        </Switch>
        <Footer/>
      </Router>
    </>
  );
}
export default App;
